export default __webpack_public_path__ + "static/media/yohannes.e5236116.jpg";